import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ResponseStatus, ValidationMessage } from '../../enum';
import { CommonService } from 'src/@services/common.service';
import { FormService } from 'src/@services/form.service';
import { CommonPagesService } from '../../common-pages.service';

@Component({
  selector: 'app-add-update-retailprograms',
  templateUrl: './add-update-retailprograms.component.html',
  styleUrls: ['./add-update-retailprograms.component.scss'],
  standalone: false,
})
export class AddUpdateRetailprogramsComponent implements OnInit {
  isVisibleRetailProgramsDrawer = true;
  isLoadingOne = false;
  retailProgramsDrawerTitle = 'Add New Retail Program';
  @Output() hideRetailProgramsDrawer = new EventEmitter();
  @Input() retailProgramsData: any;
  validationMessage = ValidationMessage;
  retailProgramLogo: string | null = null;
  retailProgramBannerImages: string | null = null;
  retailProgramLogoFile: File | null = null;
  retailProgramBannerImagesFile: File | null = null;
  sites: Array<{ id: string; name: string }> = [];
  isFetchingProgramDetails:boolean = true

  readonly MAX_FILE_SIZE = 20 * 1024 * 1024; // 20MB (updated to match help text)
  readonly ALLOWED_TYPES = ['image/jpeg', 'image/png', 'image/jpg'];
  readonly MAX_DIMENSIONS = {
    logo: { width: 500, height: 500 },
    banner: { width: 1200, height: 400 }
  };

  // Add a property to track if we're in edit mode
  get isEditMode(): boolean {
    return this.retailProgramsData != null;
  }

  constructor(
    public _cS: CommonService,
    private _ws: CommonPagesService,
    public _fS: FormService
  ) {
    _fS.retailProgramsForm_fb();
  }

  ngOnInit(): void {
    this.loadSites(); // Always load sites for dropdown
    if (this.retailProgramsData != null) {
      this.retailProgramsDrawerTitle = 'Edit Retail Program (' + this.retailProgramsData.name + ')';
      // Normalize isActive value to boolean for checkbox
      // let isActive = false;
      // if (typeof this.retailProgramsData.isActiveRetailPrograms !== 'undefined') {
      //   isActive = !!this.retailProgramsData.isActiveRetailPrograms;
      // } else if (typeof this.retailProgramsData.isActive !== 'undefined') {
      //   isActive = this.retailProgramsData.isActive === true || this.retailProgramsData.isActive === 1 || this.retailProgramsData.isActive === '1';
      // } else if (typeof this.retailProgramsData.status !== 'undefined') {
      //   isActive = this.retailProgramsData.status === true || this.retailProgramsData.status === 1 || this.retailProgramsData.status === '1';
      // }

      // Get the site name for the existing site ID
      // const existingSiteId = this.retailProgramsData.operatorSiteId || this.retailProgramsData.siteId || '';
      // const existingSite = this.sites.find(site => site.id === existingSiteId);

      this._fS.retailProgramsForm.patchValue({
        programName: this.retailProgramsData.name,
        isActiveRetailPrograms: this.retailProgramsData.status === 1 || this.retailProgramsData.status === true,
        invoiceDescriptionText: this.retailProgramsData.invoiceDescriptionText || '',
        // siteId: existingSiteId,
        // siteName: existingSite ? existingSite.name : '' // Add siteName
      });

      // Load existing images if available
      this.retailProgramLogo = this.retailProgramsData.retailProgramLogo || this.retailProgramsData.logo || null;
      this.retailProgramBannerImages = this.retailProgramsData.retailProgramBannerImages || this.retailProgramsData.banner || null;
      this.retailProgramLogoFile = null;
      this.retailProgramBannerImagesFile = null;
      // this.isFetchingProgramDetails = false;
    } else {
      this.retailProgramLogo = null;
      this.retailProgramBannerImages = null;
      this.retailProgramLogoFile = null;
      this.retailProgramBannerImagesFile = null;
    }
  }

  // Load sites for dropdown
  loadSites() {
    this.isFetchingProgramDetails = true;
    this._ws.getOperatorSites().subscribe(
      (response: any) => {
        if (response.status === ResponseStatus.success || response.responseStatus === ResponseStatus.success) {
          this.sites = response.data || response.result || [];

          // After loading sites, if we're editing and have a siteId, populate the siteName
          if (this.retailProgramsData && this.retailProgramsData.operatorSiteId) {
            const existingSite = this.sites.find(site => site.id === this.retailProgramsData.operatorSiteId);
            if (existingSite) {
              this._fS.retailProgramsForm.patchValue({
                // siteName: existingSite.name
                siteId: existingSite.id
              });
            }
          }
          this.isFetchingProgramDetails = false;
        } else {
          this.sites = [];
          this.isFetchingProgramDetails = false;
        }
      }
    );
  }

  // Enhanced file validation with custom message service
  onFileChanged(event: any, type: 'retailProgramLogo' | 'retailProgramBannerImages', showMessage: boolean = true) {
    const file = event.target.files[0];
    const input = event.target as HTMLInputElement;

    if (!file) {
      this._cS.displayMessage('error', 'Please select a file');
      return;
    }

    // Validate file type
    if (!this.ALLOWED_TYPES.includes(file.type)) {
      this._cS.displayMessage('error', 'Only JPEG, PNG, and JPG files are allowed');
      input.value = '';
      return;
    }

    // Validate file size
    if (file.size > this.MAX_FILE_SIZE) {
      this._cS.displayMessage('error', 'File size must be less than 20MB');
      input.value = '';
      return;
    }

    // Validate image dimensions
    this.validateImageDimensions(file, type, input, showMessage);
  }

  private validateImageDimensions(file: File, type: 'retailProgramLogo' | 'retailProgramBannerImages', input: HTMLInputElement, showMessage: boolean) {
    const img = new Image();
    const reader = new FileReader();

    reader.onload = (e: any) => {
      img.src = e.target.result;

      img.onload = () => {
        // const maxDimensions = type === 'retailProgramLogo' ? this.MAX_DIMENSIONS.logo : this.MAX_DIMENSIONS.banner;

        // if (img.width > maxDimensions.width || img.height > maxDimensions.height) {
        //   const errorMsg = `${type === 'retailProgramLogo' ? 'Logo' : 'Banner'} dimensions must be ${maxDimensions.width}x${maxDimensions.height} pixels or smaller`;
        //   this._cS.displayMessage('error', errorMsg);
        //   input.value = '';
        //   return;
        // }

        // All validations passed - proceed with upload
        this.processFileUpload(file, type, input, showMessage, e.target.result);
      };

      img.onerror = () => {
        this._cS.displayMessage('error', 'Invalid image file');
        input.value = '';
      };
    };

    reader.readAsDataURL(file);
  }

  private processFileUpload(file: File, type: 'retailProgramLogo' | 'retailProgramBannerImages', input: HTMLInputElement, showMessage: boolean, previewUrl: string) {
    // Set preview immediately
    if (type === 'retailProgramLogo') {
      this.retailProgramLogoFile = file;
      this.retailProgramLogo = previewUrl;
      // Update form control and mark as touched
      this._fS.retailProgramsForm.patchValue({ logo: previewUrl });
      this._fS.retailProgramsForm.get('logo')?.markAsTouched();
    } else {
      this.retailProgramBannerImagesFile = file;
      this.retailProgramBannerImages = previewUrl;
      // Update form control and mark as touched
      this._fS.retailProgramsForm.patchValue({ banner: previewUrl });
      this._fS.retailProgramsForm.get('banner')?.markAsTouched();
    }

    // Prepare FormData for upload
    const formData = new FormData();
    formData.append('File', file);
    formData.append('Screen', type === 'retailProgramLogo' ? 'RetailProgramLogo' : 'RetailProgramBanner');

    this._ws.fileUpload(formData).subscribe(
      (response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          const url = response.result[0];
          const urlWithTimestamp = url ? url + '?t=' + new Date().getTime() : '';

          if (type === 'retailProgramLogo') {
            this.retailProgramLogo = urlWithTimestamp;
          } else {
            this.retailProgramBannerImages = urlWithTimestamp;
          }

          if (showMessage) {
            this._cS.displayMessage('success', 'Image uploaded successfully');
          }
          input.value = '';
        } else {
          const errorMsg = response.message || 'Upload failed';
          this._cS.displayMessage('error', errorMsg);
          input.value = '';
        }
      },
      (error: any) => {
        this._cS.displayMessage('error', 'Image upload failed');
        input.value = '';
      }
    );
  }

  // Enhanced remove image with proper form control clearing
  removeImage(type: 'retailProgramLogo' | 'retailProgramBannerImages') {
    if (type === 'retailProgramLogo') {
      this.retailProgramLogo = null;
      this.retailProgramLogoFile = null;
      // Clear the form control
      this._fS.retailProgramsForm.patchValue({ logo: '' });
      // Mark the control as touched to trigger validation
      this._fS.retailProgramsForm.get('logo')?.markAsTouched();
    } else {
      this.retailProgramBannerImages = null;
      this.retailProgramBannerImagesFile = null;
      // Clear the form control
      this._fS.retailProgramsForm.patchValue({ banner: '' });
      // Mark the control as touched to trigger validation
      this._fS.retailProgramsForm.get('banner')?.markAsTouched();
    }

    // Sync form state after removal
    this.syncFormWithImages();
  }

  // Add method to sync form state with image state
  private syncFormWithImages() {
    // Update form controls to match current image state
    this._fS.retailProgramsForm.patchValue({
      logo: this.retailProgramLogo || '',
      banner: this.retailProgramBannerImages || ''
    });

    // Mark controls as touched to trigger validation
    if (this.retailProgramLogo) {
      this._fS.retailProgramsForm.get('logo')?.markAsTouched();
    }
    if (this.retailProgramBannerImages) {
      this._fS.retailProgramsForm.get('banner')?.markAsTouched();
    }
  }

  handleCancel() {
    this.isVisibleRetailProgramsDrawer = false;
    this.hideRetailProgramsDrawer.emit({ hide: this.isVisibleRetailProgramsDrawer, data: null });
  }

  // Enhanced form validation with better debugging
  handleOk() {

    // Validate required images before form submission
    if (!this.retailProgramLogo) {
      this._cS.displayMessage('error', 'Program logo is required');
      return;
    }
    if (!this.retailProgramBannerImages) {
      this._cS.displayMessage('error', 'Program banner is required');
      return;
    }

    // Update form controls with image values
    this._fS.retailProgramsForm.patchValue({
      logo: this.retailProgramLogo,
      banner: this.retailProgramBannerImages
    });

    // Check form validity
    if (!this._fS.retailProgramsForm.valid) {
      this._cS.markFormGroupTouched(this._fS.retailProgramsForm);
      return;
    }

    // All validations passed
    const formValue = this._fS.retailProgramsForm.value;
    const selectedSite = this.sites.find(site => site.id === formValue.siteId);

    const retailProgramBody = {
      id: this.retailProgramsData != null ? this.retailProgramsData.id : '',
      name: formValue.programName.trim(),
      status: formValue.isActiveRetailPrograms == true ? 1 : 0,
      logo: this.retailProgramLogo,
      banner: this.retailProgramBannerImages,
      operatorSiteId: formValue.siteId,
      operatorSiteName: selectedSite ? selectedSite.name : '',
      invoiceDescriptionText: formValue.invoiceDescriptionText
    };

    if (this.retailProgramsData != null) {
      this.updateRetailProgramData(retailProgramBody);
    } else {
      this.addRetailProgramData(retailProgramBody);
    }
  }

  addRetailProgramData(retailProgramBody: any) {
    this.isLoadingOne = true;
    this._ws.AddRetailPrograms(retailProgramBody).subscribe(
      (response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          this._cS.displayMessage('success', response.message);

          //hide unit drawer
          this.isVisibleRetailProgramsDrawer = false;
          this.isLoadingOne = false;
          this.hideRetailProgramsDrawer.emit({
            hide: this.isVisibleRetailProgramsDrawer,
            data: response.result,
          });
        } else {
          this._cS.displayMessage('error', response.message);
          this.isLoadingOne = false;
        }
      },
      (error: any) => {
        this.isLoadingOne = false;
      }
    );
  }
  updateRetailProgramData(retailProgramBody: any) {
    this.isLoadingOne = true;
    this._ws.UpdateRetailPrograms(retailProgramBody).subscribe(
      (response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          this._cS.displayMessage('success', response.message);

          //hide unit drawer
          this.isVisibleRetailProgramsDrawer = false;
          this.isLoadingOne = false;
          this.hideRetailProgramsDrawer.emit({
            hide: this.isVisibleRetailProgramsDrawer,
            data: response.result,
          });
        } else {
          this._cS.displayMessage('error', response.message);
          this.isLoadingOne = false;
        }
      },
      (error: any) => {
        this.isLoadingOne = false;
      }
    );
  }

  // Enhanced site change handler - only allow changes in add mode
  onSiteChange(siteId: string) {
    // Only allow site changes in add mode, not edit mode
    if (this.isEditMode) {
      return;
    }

    // const selectedSite = this.sites.find(site => site.id === siteId);
    // if (selectedSite) {
    //   this._fS.retailProgramsForm.patchValue({
    //     siteName: selectedSite.name
    //   });
    // }
  }

}
